import { render, staticRenderFns } from "./forwardingReport.vue?vue&type=template&id=fdcf349a&scoped=true&"
import script from "./forwardingReport.vue?vue&type=script&lang=js&"
export * from "./forwardingReport.vue?vue&type=script&lang=js&"
import style0 from "./forwardingReport.vue?vue&type=style&index=0&id=fdcf349a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdcf349a",
  null
  
)

export default component.exports